import "../styles/sobre.css";
import ScrollAnimation from "./ScrollAnimation";

import LogoSenna from "../assets/avatarLogo.png";

function Sobre() {
  return (
    <div className="Sobre">
      <h1 className="titleSobre">Sobre Senna Viannini</h1>

      <ScrollAnimation animation="fade-up" duration={1500}>
        <div className="firstSobre">
          <img src={LogoSenna}></img>
          <div className="textSobre">
            <p>
              Na Senna Viannini Imóveis, acreditamos que cada imóvel é muito mais do que uma propriedade: é a realização de um sonho, a construção de memórias e um investimento sólido para o futuro.
              <br></br><br></br>Combinamos sofisticação, credibilidade e expertise no mercado imobiliário para oferecer a você uma experiência única na busca pela casa ideal ou pelo investimento certo. Nosso compromisso é unir exclusividade, confiança e personalização, acompanhando cada etapa do processo com transparência e dedicação.
              <br></br><br></br>Aqui, você encontra não apenas imóveis de alto padrão, mas também a certeza de contar com uma equipe preparada para transformar seu desejo em realidade.
              <br></br><br></br>Senna Viannini Imóveis – transformando seu sonho de moradia em realidade e seu investimento em patrimônio sólido.
            </p>
          </div>
        </div>
      </ScrollAnimation>
    </div>
  );
}

export default Sobre;
